import script from "./BasePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePagination.vue?vue&type=script&setup=true&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=174dd1ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174dd1ab"]])

export default __exports__